import React from "react";
import { HashLoader } from "react-spinners";

const LoadingSpinner = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-20">
      <HashLoader color={"#f26522"} loading={true} size={50} />
    </div>
  );
};

export default LoadingSpinner;
